import React from 'react';
import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';

export const ArrearsFlyoutFooterMainContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        marginTop: 'auto',
        width: '100%',
        position: 'sticky',
        bottom: 0,
        zIndex: 1,
        backgroundColor: '#FFFFFF'
      }}
    >
      <Divider />
      <Box
        padding="32px"
        display="flex"
        justifyContent="center"
        gap="24px"
        alignItems="flex-end"
        alignSelf="stretch"
      >
        {children}
      </Box>
    </Box>
  );
};
